import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sale-item-delete-conformation-dialog',
  standalone: false,
  
  templateUrl: './sale-item-delete-conformation-dialog.component.html',
  styleUrl: './sale-item-delete-conformation-dialog.component.scss'
})
export class SaleItemDeleteConformationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<SaleItemDeleteConformationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { sale_item_name: string }
  ) {}

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

}
